import { pick } from 'ramda';
import React from 'react';
import { useUserSelector } from 'js/store/hooks';

export const PortletTitle = ({ portlet }) => {
    const { role } = useUserSelector(pick(['role']));
    const { title, showBorders } = portlet;

    if (!showBorders) {
        if (role === 'admin') {
            return (
                <div className={'portlet-title fn-portlet-title'}>
                    <span className="fn-portlet-title-region portlet-title__text-wrapper" />
                </div>
            );
        }
        return null;
    }

    return (
        <div className={'portlet-title fn-portlet-title'}>
            <span
                className="fn-portlet-title-region portlet-title__text-wrapper">
                <span className="portlet-title-text">
                    {title}
                </span>
            </span>
        </div>
    );
};
